import DashBoardNav from '@/layout/DashBoardNav'

export default [{
  path: '/messages',
  component: DashBoardNav,
    children: [{
      path: '/messages',
      component: () => import('@/components/administration/messages')
    }
  ]
}]
